var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-white overflow-hidden sm:rounded-t-2xl sm:rounded-br-2xl border-vectric border-4"},[_c('ul',_vm._l((_vm.topics),function(topic,idx){return _c('li',{key:idx,class:{ 'border-t border-gray-200': idx > 0 }},[_c('topic-table-row',{attrs:{"topic":topic}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }